import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { FileInfo } from 'models/admin/FileInfo';
import { callApi, API_BASE_URL } from 'utils/ApiUtil';
import axios from 'axios';

export const getAtchFileGrId = async () => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/file/upload/getAtchFileGrId`,
    serviceName: ServiceName.ELM_BE,
    headers: {},
  };
  const response: CommonResponse<FileInfo> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as FileInfo;
};

export const findFiles = async (atchFileGrId: string, atchFileTpCd?: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/files`,
    serviceName: ServiceName.ELM_BE,
    headers: {},
    queryParams: new URLSearchParams({
      atchFileGrId: atchFileGrId,
      atchFileTpCd: atchFileTpCd || '',
    }),
  };
  const response: CommonResponse<FileInfo[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as FileInfo[];
};

export const uploadFiles = async (formData: FormData) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/file/upload`,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    serviceName: ServiceName.ELM_BE,
    bodyParams: formData,
  };

  const response: CommonResponse<any> = await callApi(request);

  return response.successOrNot === 'Y' ? response.data : null;
};

export const convertFiles = async (formData: FormData) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/file/convert`,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    serviceName: ServiceName.ELM_BE,
    bodyParams: formData,
  };

  const response: CommonResponse<any> = await callApi(request);

  return response.successOrNot === 'Y' ? response.data : null;
};

export const uploadFileWithNewGroupId = async (formData: FormData) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/file/upload/new`,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    serviceName: ServiceName.ELM_BE,
    bodyParams: formData,
  };

  const response: CommonResponse<any> = await callApi(request);

  return response.successOrNot === 'Y' ? response.data : null;
};

export const modifyFiles = async (files: FileInfo[]) => {
  const request: CommonRequest = {
    method: Method.PUT,
    url: `/v1/files`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: files,
  };

  const response: CommonResponse<any> = await callApi(request);

  return response.successOrNot === 'Y' ? response.data : null;
};

export const modifyFilesWithNewGroupId = async (atchFileGrId: string, files: FileInfo[]) => {
  const request: CommonRequest = {
    method: Method.PUT,
    url: `/v1/files/new`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: {
      atchFileGrId: atchFileGrId,
      files: files,
    },
  };

  const response: CommonResponse<any> = await callApi(request);

  return response.successOrNot === 'Y' ? response.data : null;
};

export const downloadFile = async (atchFileGrId: string, atchFileId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/file/download`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ atchFileGrId: atchFileGrId, atchFileId: atchFileId }),
  };

  const response = await callApi(request);

  return response.data;
};

export const downloadAllFiles = async (atchFileGrId: string, atchFileTpCd: string) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/v1/file/download/all?atchFileGrId=${atchFileGrId}&atchFileTpCd=${atchFileTpCd}`,
      {
        responseType: 'blob',
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', atchFileGrId + '.zip');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.log(error);
  }
};
